// Define fixed column order
const fixedColumns: string[] = [
  'Users.username.label',
  'Users.firstname.label',
  'Users.lastname.label',
  'Users.statuskey.label',
];

export default fixedColumns;
